import { render, staticRenderFns } from "./CompanyOthers.vue?vue&type=template&id=9db94c98"
import script from "./CompanyOthers.vue?vue&type=script&lang=js"
export * from "./CompanyOthers.vue?vue&type=script&lang=js"
import style0 from "./CompanyOthers.vue?vue&type=style&index=0&id=9db94c98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports